// extracted by mini-css-extract-plugin
export var active = "_e4-7";
export var container = "_e4-0";
export var evenWidth = "_e4-4";
export var large = "_e4-5";
export var outlet = "_e4-8";
export var slide = "_e4-2";
export var small = "_e4-6";
export var tab = "_e4-3";
export var tabs = "_e4-1";